import { formatISO, format } from "date-fns";

import ConfigService from "../services/ConfigService.js";
import CoreService from "../services/CoreService.js";
import LocalStorageService from "../services/LocalStorageService.js";
import IdentityService from "../services/IdentityService.js";
import NotificationService from "../services/NotificationService.js"

import ServiceResponse from "../models/ServiceResponse.js";

import ReportDataFactory from "../pages/ReportViewer/Reports/Managers/ReportDataFactory.js";

import JavascriptHelpers from "../components/lib/Javascript/JavascriptHelpers.js";






function saveJsonToFile(obj, flName)
{
    var jsonString = JSON.stringify(obj);
    var jsonFlName = flName + ".json";
    const link = document.createElement("a");
    const file = new Blob([jsonString], { type: 'application/json' });
    link.href = URL.createObjectURL(file);
    link.download = jsonFlName;
    link.click();
    URL.revokeObjectURL(link.href);
}


export default class SubscriptionManager
{
    constructor()
    {
        this.configService = new ConfigService();
        this.coreService = new CoreService();
        this.localStorageService = new LocalStorageService();
        this.notificationService = new NotificationService();
    }


    async sendSubscriptions(observation, observationSchema, uid, gcid, token)
    {
        var sendResponse = new ServiceResponse(false, ["initializing Subscription send."]);

        // does the observation schema even have a subscriptionId?
        var schemaId = observationSchema.schemaInfo.id;
        var subscriptionId = observationSchema.subscription?.subscriptionId;
        if (!subscriptionId)
        {
            return new ServiceResponse(false, schemaId + " Schema does not have a subscription Id assigned to it. No subscriptions sent.");
        }

        // fetch the subscription Org Schema
        var subscriptionOrgSchemaResult = await this.coreService.fetchSubscriptionOrgSchema(subscriptionId, gcid, token);
        if (subscriptionOrgSchemaResult.hasError)
        {
            let msgs = subscriptionOrgSchemaResult.messages;
            msgs.unshift("There was a problem fetching the Subscription Schema for Org " + gcid);
            return new ServiceResponse(true, msgs);
        }
        var orgSchema = subscriptionOrgSchemaResult.dataResult;
        // did any rules get triggered by this observation?
        var triggeredRules = [];
        orgSchema.rules.forEach((rule) =>
        {
            var isRuleTriggered = false;
            rule.ruleTriggers.forEach((ruleTrigger) => 
            {
                if (!isRuleTriggered)
                {
                    var testTriggerValue = JavascriptHelpers.getPathValue(observation, ruleTrigger.path); //observation[ruleTrigger.path];
                    isRuleTriggered = (testTriggerValue === ruleTrigger.value);
                }
            });
            if (isRuleTriggered)
            {
                triggeredRules.push(rule);
                sendResponse.messages.push("Rule " + rule.metadata.name + " (" + rule.metadata.description + ") has been triggered.");
            }
        });
        // if NO rules were triggered, then return.
        if (triggeredRules.length < 1) return new ServiceResponse(false, "No subscription rules were triggered by this observation.");
        var triggeredRuleIds = triggeredRules.map((tr) => tr.metadata.name);

        // now for each of the POTENTIAL subscribers, lets figure out if they match. We can SKIP the foreignProp trigger selector because we've already tested for that.
        var subscriberList = [];
        var subscriptionSubscribersResult = await this.coreService.fetchSubscriberList(gcid, token, false);
        if (subscriptionSubscribersResult.hasError)
        {
            let msgs = subscriptionSubscribersResult.messages;
            msgs.unshift("There was a problem fetching the Subscription Subscribers for " + gcid);
            return new ServiceResponse(true, msgs);
        }
        var potentialSubscriberList = subscriptionSubscribersResult.dataResult;
        potentialSubscriberList.forEach((subscriber) =>
        {
            var subscription = subscriber.subscriptions.find((subscription)=> subscription.name.toLowerCase() === subscriptionId.toLowerCase());
            // does this subscriber actually subscriber to any of the rules that were triggered? 
            // get all subscriber's rules
            var subscriberRuleIds = subscription.rules;
            let isTriggered = subscriberRuleIds.some( rule => triggeredRuleIds.includes(rule) );
            // if NO rules then this subscriber is OUT
            if (isTriggered)
            {
                // it MUST exist or we wouldn't even be here, right? 
                // must match EACH selector
                subscription.selections.forEach((selection) => 
                {
                    if (isTriggered)
                    {
                        if (!selection.values.includes("ALL")) // don't test this AGAIN if it's the foreign prop OR if the value is ALL
                        {
                            // find this selection in our subscription schema
                            var selectionTrigger = orgSchema.subscriberFilters.selectionTriggers.find((trigger) => trigger.metadata.name === selection.name);
                            // tbd - what happens if this is null? 
                            var sub = subscriber;
                            try
                            {
                            let observationValue = JavascriptHelpers.getPathValue(observation, selectionTrigger.schema.path); //observation[selectionTrigger.schema.path];
                            isTriggered = selection.values.includes(observationValue);
                            } catch(e)
                            {
                                console.log(sub);
                            }
                        }
                    }
                });    
                if (isTriggered)
                {
                    subscriberList.push(subscriber);
                }      
            }
        });
        // if we don't have any actual subscribers at THIS point, then return that.
        if (subscriberList.length < 1)
        {
            sendResponse.messages.push("No subscribers were triggered by this observation");
            return sendResponse;
        }
        else
        {
            sendResponse.messages.push(subscriberList.length.toString() + " subscribers were triggered by this observation.");
        }


        // we want to build a structure of document->>rule->>subscriber
        var result = [];
        // if we are HERE, then we're ready to actually send subscriber notifications. 
        subscriberList.forEach((subscriber) => 
        {
            var subscription = subscriber.subscriptions.find((subscriptions) => subscriptions.name.toLowerCase() === subscriptionId.toLowerCase());
            // we will send the subscriber each document they have subscribed to. The difficulty is that we only 
            // want to send them one "flavor" (rule) of each document. What is the priority? It's always the FIRST
            // matching rule.

            // TBD - there MUST be a rule trigger for us to be here?
            var subscriberPriorityRule = this.subscriberPriorityRule(subscription, triggeredRules);
            subscription.documents.forEach((document) => {
                var subscriptionDocument = orgSchema.documents.find((doc) => doc.name === document);
                this.findOrAdd(result, subscriptionDocument, subscriberPriorityRule, subscriber);
            });

        });

        var emailNotifications = [];
        var smsNotifications = [];

        for(const res of result)
        {
        //result.forEach((res) => {
            for(const rule of res.rules)
            {
            //res.rules.forEach((rule)=> {
                if (res.document.transportType === "email")
                {
                    // get an array of to addresses
                    var toAddresses = rule.subscribers.map((subscriber) => subscriber.transportInfo.email.address);
                    var templateId = res.document.transportInfo.templateId;
                    var ruleInfo = res.document.ruleInfo.find((ri) => ri.id.toLowerCase() === rule.id.metadata.name.toLowerCase());
                    var subject = this.replaceTemplatesWithValues(observation, ruleInfo.subjectTemplate); 
                    var message = this.replaceTemplatesWithValues(observation, ruleInfo.messageTemplate); 
                    var reportName = orgSchema.observationDataFactoryType;
                    var notificationsDataResponse = await this.getEmailDirectNotificationResult(reportName, uid, toAddresses, subject, message, observation, templateId, gcid, token);
                    emailNotifications.push(notificationsDataResponse);

                }
                else if (res.document.transportType === "sms")
                {
                    for (const subscriber of rule.subscribers) 
                    {
                    //rule.subscribers.forEach((subscriber) => {
                        var toAddress = subscriber.transportInfo.sms.address;
                        var ruleInfo = res.document.ruleInfo.find((ri) => ri.id.toLowerCase() === rule.id.metadata.name.toLowerCase());
                        var message = this.replaceTemplatesWithValues(observation, ruleInfo.messageTemplate); // TBD do the prop replacements.
                        // special link 
                        if (res.document.includeShortUrl)
                        {
                            // we need to POST the shortUrl querystring
                            var hostAddr = this.configService.getAppHost();
                            //const claimToken = queryStringValues.ct; // password - injected on the backend.
                            //const gcid = queryStringValues.gcid;
                            //const observationId = queryStringValues.oid;
                            //const reportName = queryStringValues.rn;
                            var reportName = orgSchema.observationDataFactoryType;
                            var shortUrlKey = IdentityService.makeUuid();
                            var queryString = "gcid=" + gcid + "&oid=" + observation.identifiers.id + "&rn=" + reportName;
                            try
                            {
                                var postShortUrlResult = await this.coreService.postShortUrlQuery(shortUrlKey, queryString, gcid, token);
                            }
                            catch (e)
                            {
                                var err = e;
                            }
                            var reportLink = hostAddr + "?su=" + shortUrlKey;
                            var message = message.replace(res.document.shortUrlTemplateKey, reportLink);

                        }
                        
                        smsNotifications.push({gcid: gcid, recipient: toAddress, msg: message});
                    //});
                    }
                }
            }
        }

        // finally, deliver!
        var msgs = [];
        for (const notification of emailNotifications) 
        {
            var postResult = await this.notificationService.postScheduledNotificationRequest(notification, gcid, token);  
            if (postResult.hasError)
            {
              hasError = true;
              sendResponse.hasError = true;
              sendResponse.messages.push("Error sending Email Notification");
              sendResponse.messages.concat(postResult.messages?? []);

            }
            sendResponse.messages.push("posted email notification to " + notification.toList.join(", ")); 
        }

        for (const sms of smsNotifications)
        {
            var postResult = await this.notificationService.postScheduledSmsRequest(sms, gcid, token);  
            if (postResult.hasError)
            {
                hasError = true;
                sendResponse.hasError = true;
                sendResponse.messages.push("Error sending Text Notification");
                sendResponse.messages.concat(postResult.messages?? []);
            }
            sendResponse.messages.push("posted text notification to " + sms.recipient); 
        }

        return sendResponse;

    }


    subscriberPriorityRule(subscription, triggeredRules)
    {
        for (var i=0; i<triggeredRules.length; i++)
        {
            var triggeredRule = triggeredRules[i];
            if (subscription.rules.includes(triggeredRule.metadata.name))
            {
                return triggeredRule;
            }
        }
        // TBD: if we're here we have a problem. 
    }


    findOrAdd(result, subscriptionDocument, rule, subscriber)
    {
        // does the result have the document yet?
        var docNode = result.find((r) => r.document?.id === subscriptionDocument.id);
        if (!docNode)
        {
            docNode = {document: subscriptionDocument, rules: []};
            result.push(docNode);
        }
        // does the rule exist for the document?
        var ruleNode = docNode.rules.find((r) => rule.id);
        if (!ruleNode)
        {
            ruleNode = {id: rule, subscribers: []};
            docNode.rules.push(ruleNode);
        }
        // add subscriber
        ruleNode.subscribers.push(subscriber);
        return result;
    }


    async getEmailDirectTestNotificationResult(fromUser, toList, subject, directMessage, templateId, gcid)
    {
        var result = {
            "id": IdentityService.makeUuid(), //observation.data.identifiers.id, // TBD should be GUID unique to notification event
            "gcid": gcid,
            "sourceService": "glasschain-qa-app",
            "sourceId": "Test",
            "sourceDescript":  "Test Notification",
            "sourceSubject": subject,
            "sourceMessage": directMessage,
            "sourceComment": "created by glasschain Observations",
            "requestedBy": fromUser, //observation.data.UnderInspection.Inspector,
            "requestDate":  formatISO(new Date(), "MM/dd/yyyy"),
            "toList": toList
        };  

        /*
        console.group("Template Data");
        console.log("about to build templateData from observation object:");
        console.groupEnd();
        var reportDataResponse = await ReportDataFactory.ReportData("TestNotification", null, fromUser, gcid, token);
        if (reportDataResponse.hasError)
        {
            return reportDataResponse;
        }
        */
        var templateData = {};
        // add additional fields required by email
        var orgConfig = this.localStorageService.getOrgConfig(gcid);
        var senderLogo = this.configService.getCustomerLogoImagePath(gcid);
        var nameAppend = (orgConfig.Names?.longName) ? "from " + orgConfig.Names.longName : "";
        var receiptId =  "";
        templateData.subject = nameAppend + " QA Notification " + receiptId,
        templateData.Notification = {
            "requestDate":  format(new Date(), "MM/dd/yyyy"),
            "appHost": this.configService.getAppHost(),
            "senderGcid": gcid,
            "senderMessage": directMessage,
            "senderName": fromUser,
            "senderLogoUri": senderLogo
        }

        result.Message = {
            "templateId": templateId, 
            "fromPrefix": "observations",
            "templateData": JSON.stringify(templateData)
        };

        console.groupEnd();
        return result;

    }



    async getEmailDirectNotificationResult(reportName, fromUser, toList, subject, directMessage, observation, templateId, gcid, token)
    {
        var result = {
            "id": IdentityService.makeUuid(), //observation.data.identifiers.id, // TBD should be GUID unique to notification event
            "gcid": observation.data.Raw.gcid,
            "sourceService": "glasschain-qa-app",
            "sourceId": observation?.identifiers?.id ?? "",
            "sourceDescript": (observation) ? "Observation": "",
            "sourceSubject": subject,
            "sourceMessage": directMessage,
            "sourceComment": "created by glasschain Observations",
            "requestedBy": fromUser, //observation.data.UnderInspection.Inspector,
            "requestDate":  formatISO(new Date(), "MM/dd/yyyy"),
            "toList": toList
    };  

        console.log("about to build templateData from observation object:");
        var reportDataResponse = await ReportDataFactory.ReportData(reportName, observation, fromUser, gcid, token);
        if (reportDataResponse.hasError)
        {
            return reportDataResponse;
        }
        var templateData = reportDataResponse.data;
        // add additional fields required by email
        var orgConfig = this.localStorageService.getOrgConfig(gcid);
        var senderLogo = this.configService.getCustomerLogoImagePath(gcid);
        var nameAppend = (orgConfig.Names?.longName) ? "from " + orgConfig.Names.longName : "";
        var receiptId = (observation.data.Raw.mraInfo?.tagId) ? " for Receipt " + observation.data.Raw.mraInfo?.tagId : "";
        templateData.subject = nameAppend + " QA Notification " + receiptId,
        templateData.Notification = {
            "requestDate":  format(new Date(), "MM/dd/yyyy"),
            "appHost": this.configService.getAppHost(),
            "senderGcid": observation.data.Raw.gcid,
            "senderMessage": directMessage,
            "senderName": fromUser,
            "senderLogoUri": senderLogo
        }

        result.Message = {
            "templateId": templateId, 
            "fromPrefix": "observations",
            "templateData": JSON.stringify(templateData)
        };

        console.groupEnd();
        return result;

    }




    replaceTemplatesWithValues(observation, srcString)
    {
        //var str = 'I [have] strings that [are] like this.'

        //console.group("Template Replacement: ");
        //console.log(srcString);
        var re  = /\[([^\]]*)]/g, matches = [];
        let m = null;
        while(null != (m=re.exec(srcString))){
            matches.push(m[0])
        }
        //console.log(matches);
        var templateValues = matches.map(m =>{
            return {template: m, replacement: JavascriptHelpers.getPathValue(observation, m.replace('[','').replace(']',''))}
        });
        //console.log(templateValues);
        var result = srcString;
        templateValues.forEach(t => {
            result = result.replace(t.template, t.replacement);
        });
        //console.log(result);
        //console.groupEnd();

        return result;
    }







}